import {create, StateCreator} from 'zustand';
import {devtools} from 'zustand/middleware'
import {immer} from "zustand/middleware/immer";

import {createSelectors} from "../Utils";
import {createPrintOptionsSlice, PrintOptionsSliceProps} from "./printOptionsSlice";
import {createLabelsSlice, LabelsSliceProps} from "./labelsSlice";
import {createGlobalSlice, GlobalSliceProps} from "./globalSlice";

export interface AppStoreProps extends GlobalSliceProps, LabelsSliceProps, PrintOptionsSliceProps {}

export type ImmerStateCreator<T, Y> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  Y
>;

export const useAppStore = createSelectors(
  create<AppStoreProps>()(
    devtools(immer(
      (...a) => ({
        ...createGlobalSlice(...a),
        ...createPrintOptionsSlice(...a),
        ...createLabelsSlice(...a),
      })
    ))
  )
);

export default useAppStore;
